import React, { useState, useEffect } from "react"

async function fetchImage(src, updateSrc) {
  // const image = await S3.getimage(src)
  updateSrc(src)
}

const Image = ({ src, alt, ...props }) => {
  const [imageSrc, updateSrc] = useState(null)
  useEffect(() => {
    fetchImage(src, updateSrc)
  }, [src])

  return imageSrc ? <img src={imageSrc} alt={alt} {...props} /> : null
}

export default Image
